<template>
  <div class="m-0 p-0">
    <div class="col-12">
      <vs-select
        v-if="reference === 'DDPP'"
        autocomplete
        class="w-100"
        label="Categoría"
        :disabled="readOnly"
        @change="setCategory"
        v-model="category"
        placeholder="Elija una categoría"
        name="category"
      >
        <vs-select-item
          :key="item.opcionId"
          :value="item.opcionId"
          :text="item.descripcion"
          v-for="item in categoryOptions"
        />
      </vs-select>
    </div>
    <div class="col-12 my-2">
      <vs-select
        v-if="reference === 'DDPP' && category"
        autocomplete
        class="w-100"
        label="Documento"
        :disabled="readOnly"
        @change="setDocument"
        v-model="document"
        placeholder="Elija un documento"
        name="document"
      >
        <vs-select-item
          :key="item.opcionId"
          :value="item.opcionId"
          :text="item.descripcion"
          v-for="item in documentOptions"
        />
      </vs-select>
    </div>
    <div class="col-12">
      <vs-select
        v-if="reference === '801' || reference === 'SCO'"
        autocomplete
        class="w-100"
        label="Categoría"
        :disabled="readOnly"
        @change="setPurchaseType"
        v-model="purchaseType"
        placeholder="Elija una categoría"
        name="purchaseType"
      >
        <vs-select-item
          :key="item.opcionId"
          :value="item.valor"
          :text="item.descripcion"
          v-for="item in purchaseTypeOptions"
        />
      </vs-select>
    </div>
    <div class="col-12">
      <vs-select
        v-if="reference === 'RD2'"
        autocomplete
        class="w-100"
        label="Tipo de rendición"
        :disabled="readOnly"
        @change="setReportType"
        v-model="reportType"
        placeholder="Elija un tipo de rendición"
        name="reportType"
      >
        <vs-select-item
          :key="item.opcionId"
          :value="item.valor"
          :text="item.descripcion"
          v-for="item in reportTypeOptions"
        />
      </vs-select>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'OptionInputs',
  props: ['reference', 'readOnly'],
  data() {
    return {
      category: '',
      document: '',
      purchaseType: '',
      reportType: '',
    };
  },
  watch: {
    async reference(val) {
      if (val === 'DDPP' && !this.category) {
        await this.getSelectsOptions({
          option: 'category',
          groupOption: 'documentos.personalizados.plantillas',
          filters: 'padre:null'
        });
      }
      if (val === '801' || val === 'SCO') {
        await this.getSelectsOptions({
          option: 'purchaseType',
          groupOption: 'tipos.compra',
        });
      }
      if (val === 'RD2') {
        await this.getSelectsOptions({
          option: 'reportType',
          groupOption: 'tipos.rendiciones',
        });
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'categoryOptions',
      'documentOptions',
      'purchaseTypeOptions',
      'reportTypeOptions',
      'aprovalTemplate'
    ])
  },
  methods: {
    ...mapActions('Approvals', ['getSelectsOptions']),
    async setCategory() {
      this.document = '';
      await this.getSelectsOptions({
        option: 'document',
        groupOption: 'documentos.personalizados.plantillas',
        filters: `padre:${this.category}`
      });
      this.$emit('category', this.category);
    },
    setDocument() {
      this.$emit('document', this.document);
    },
    setPurchaseType() {
      this.$emit('purchaseType', this.purchaseType);
    },
    setReportType() {
      this.$emit('reportType', this.reportType);
    },
  },
  created() {
    if (this.$route.params.view !== 'create') {
      this.category = this.aprovalTemplate.aprobacion?.tipoObjetoCategoria;
      this.document = this.aprovalTemplate.aprobacion?.tipoObjetoSubCategoria;
      this.purchaseType = this.aprovalTemplate.aprobacion?.tipoObjetoCategoria;
      this.reportType = this.aprovalTemplate.aprobacion?.tipoObjetoCategoria;
    }
  }
};
</script>
